import(/* webpackMode: "eager" */ "/home/bas/app_c64d46a8-83e7-491b-a9b5-0969d13be2c2/apps/web/app/error.tsx");
